import styled from 'styled-components'
import { media } from 'styles/media'

import SimpleLink from '../../../components/display/SimpleLink'

export const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme['-ds-font-size-lg']['font-size'].value};
  font-weight: 400;
  color: ${({ theme }) => theme['-ds-core-300'].value};

  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
  `}
`

export const EscapeLink = styled(SimpleLink)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }

  color: ${({ theme }) => theme['-ds-neutral-600'].value};
`

export const Item = styled.li`
  padding: 0;

  font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
  ${media.md`
    font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  `}

  font-weight: 300;
  line-height: 2;
`

export const List = styled.ul<{ columns?: number }>`
  margin: 20px 0;
  padding: 0;
  list-style: none;

  ${media.md`
    columns: ${({ columns = 3 }: { columns?: number }) => columns};
    max-width: 1000px;
  `}
`

export const Outer = styled.div`
  padding: 16px;

  ${media.md`
    padding: 60px;
  `}
`
